import { render, staticRenderFns } from "./EditOnlineCourse.vue?vue&type=template&id=6908cb1f&scoped=true"
import script from "./EditOnlineCourse.vue?vue&type=script&lang=ts"
export * from "./EditOnlineCourse.vue?vue&type=script&lang=ts"
import style0 from "./EditOnlineCourse.vue?vue&type=style&index=0&id=6908cb1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908cb1f",
  null
  
)

export default component.exports